<!--
 * @Author: Gearinger 50980099+Gearinger@users.noreply.github.com
 * @Date: 2022-02-08 18:24:52
 * @LastEditors: Gearinger 50980099+Gearinger@users.noreply.github.com
 * @LastEditTime: 2022-06-08 09:12:19
 * @FilePath: \frontend\src\components\confirm.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="confirmBox" :message="message">
    <div class="ConfirmMessage">
      <span class="el-icon-warning" />
      <span>{{ message }}</span>
    </div>
    <div class="upload-sys-select-radio">
      <el-radio v-model="radio" label="0">XAG One</el-radio>
      <el-radio v-model="radio" label="1">XAgri</el-radio>
    </div>
    <div class="ConfirmBtnBox">
      <el-button
        size="small"
        type="primary"
        class="ConfirmBtn"
        @click="confirmClick"
        >Confirm</el-button
      >
      <el-button size="small" class="ConfirmBtn" @click="cancleClick"
        >Cancel</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "confirm",
  props: {
    message: { default: "continue?" },
  },
  data() {
    return {
      radio: '0',
    };
  },
  methods: {
    confirmClick() {
      this.$emit("confirmClick", this.radio);
    },
    cancleClick() {
      this.$emit("cancleClick");
    },
  },
};
</script>
<style>
.confirmBox {
  width: 450px;
  height: 140px;
  background-color: rgba(240, 240, 250, 0.9);
  border-radius: 10px;
  padding: 10px;
}
.ConfirmMessage {
  margin: 5%;
  margin-left: 10%;
}
.ConfirmBtnBox {
  margin-left: 60%;
  margin-top: 5%;
  bottom: 0px;
}
.upload-sys-select-radio{
  padding-left: 13%;
}
</style>



// WEBPACK FOOTER //
// src/components/confirm.vue